import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_USERS_API } from "../apiRoutes";

interface UseGetBomAssociateUserByCommunityIdProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBomAssociateUserByCommunityId = async (communityId: string) =>
  await axiosAuth.get(
    `${BOM_USERS_API}/associate-users?communityId=${communityId}`
  );

const useGetBomAssociateUserByCommunityId = ({
  communityId,
  queryParams,
}: UseGetBomAssociateUserByCommunityIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bomAssociateUser", communityId],
    queryFn: () => getBomAssociateUserByCommunityId(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetBomAssociateUserByCommunityId;
